import { Pipe, PipeTransform } from "@angular/core";
import { Translation } from "../models/entities/translation";

@Pipe({ name: "ppTranslate" })
export class PPTranslatePipe implements PipeTransform {
  transform(value: Translation[], placeholder?: string): string {
    if (!value || !value.length) {
      return placeholder || "";
    }
    if (value.length == 1) {
      return value[0].Value;
    }
    return value[0].Value;
    const found = value.find((t) => t.Language.Code == "IT");
    if (!found) {
      return "";
    }
    return found.Value;
  }
}
